import axios from 'axios'

import { ChanneledRequestParams, Specialisation } from 'modules/Monitoring/types'

export const getSpecialisations = async (params: ChanneledRequestParams) => {
  return (
    await axios.get<Specialisation[]>('/specialisations', {
      params,
    })
  ).data
}
